/**
 * MinigameContent.js
 * 
 * Created on Dec 2, 2013
 *
 * @author Olivier van der Pool for Ranj
 **/

import Content from "./Content";

export default class MinigameContent extends Content {
    constructor(languagePack, contentID, label) {
        super(MinigameContent.NAME, MinigameContent.TYPE, label, languagePack, contentID);
    }

    setID(value) {
        if (this.getID() !== value) {
            this.setLanguagePackText(MinigameContent.TEXT_LABEL, value);
        }
    }

    getID() {
        return this.getLanguagePackText(MinigameContent.MINIGAME_ID_LABEL);
    }

    setMinigameType(value) {
        if (this.getType() !== value) {
            this.setLanguagePackText(MinigameContent.MINIGAME_TYPE_LABEL, value);
        }
    }

    getMinigameType() {
        return this.getLanguagePackText(MinigameContent.MINIGAME_TYPE_LABEL);
    }

    getPlayerInitiated() {
        return this._playerInitiated;
    }

    setPlayerInitiated(value) {
        if (this._playerInitiated !== value) {
            this._playerInitiated = value;
        }
    }

    remove() {
        this.removeLanguagePackText(MinigameContent.MINIGAME_TYPE_LABEL);
        this.setType(null);
        super.remove();
    }

    convertToObject() {
        return Content.getObject(["playerInitiated"]);
    }
}

MinigameContent.NAME = "MINIGAME";
MinigameContent.TYPE = "engMinigameContent";
MinigameContent.MINIGAME_ID_LABEL = "minigameID";
MinigameContent.MINIGAME_TYPE_LABEL = "minigameType";
